const rolesWebCId = {
  accion: [{ path: '/', sub: null }],
  label: 'Usuario general',
};

export default rolesWebCId;
